import { useQuery } from "@tanstack/react-query";
import type { FC } from "react";
import React from "react";

import { JobSyncStatus } from "@react/domains/jobs";
import { Skeleton } from "@react/ui-primitives/skeleton";

import { ADMIN_SERVICE } from "@apis/admin/config";

import { useQueries } from "../../../shared/hooks/useQueries.ts";

interface TableSyncStatusProps {
  readonly isSending: boolean;
  readonly onSync: () => void;
  readonly tableName: string;
}

export const TableSyncStatus: FC<TableSyncStatusProps> = ({
  isSending,
  onSync,
  tableName,
}) => {
  const { getJobsQueryOptions } = useQueries();
  const latestJobs = useQuery(
    getJobsQueryOptions({
      limit: 1,
      order: "desc",
      principalId: ADMIN_SERVICE.ID,
      resourceId: tableName,
      type: ADMIN_SERVICE.JOB_TYPES.tableSync,
    }),
  );

  if (latestJobs.status !== "success") {
    return <Skeleton deferred variant="text-label" />;
  }

  return (
    <JobSyncStatus
      isSending={isSending}
      job={latestJobs.data.items[0]}
      onSync={onSync}
    />
  );
};
